import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { getCurrentTime, genericDateFormat, getTimezoneAbbreviation, } from '../../utils';
import { defaultLocale } from '../../types';
import { DateTime } from 'luxon';
const LiveClock = ({ className, timezone, showTimezoneAbbreviation, dateTimeFormat = defaultLocale.fullDateTimeFormat, }) => {
    // ISO 8601 format
    const [dateTime, setDateTime] = useState(getCurrentTime());
    useEffect(() => {
        const timer = setInterval(() => {
            const currentDateTime = getCurrentTime();
            setDateTime(currentDateTime);
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    return (_jsxs("div", Object.assign({ className: className }, { children: [genericDateFormat(DateTime.fromISO(dateTime).toJSDate(), dateTimeFormat, timezone), showTimezoneAbbreviation &&
                timezone &&
                ` (${getTimezoneAbbreviation(timezone)})`] }), void 0));
};
export default LiveClock;
